import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../globalInspector/axiosInstance";
import { env } from "../../../../env";
import { toast } from "react-toastify";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const taxCompliantViewAll = createAsyncThunk(
  "taxCompliantViewAll/fetch",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      approval_status,
      category,
      search_string,
      section_name,
      bank_account_no,
      ifsc,
      start_date,
      end_date,
      pan,
      labels,
      gstin,
      type_of_account,
      linked_beneficiary_id,
      type,
      created_via,
      sort_by,
      associate,
    } = values;

    try {
      const response = await axiosInstance.get(`${baseUrl}/accounts/tds`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no,
          page_size,
          approval_status: associate
            ? associate
            : approval_status && approval_status.length > 0
              ? type === "homeDashboard"
                ? approval_status
                : [approval_status]
              : type === "homeDashboard"
                ? []
                : "",
          search_string,
          start_date,
          end_date,
          bank_account_no,
          ifsc,
          category: category,
          pan,
          labels,
          section_name,
          gstin,
          type_of_account,
          created_via,
          linked_beneficiary_id,
          sort_by,
        },
      });

      return response.data;
    } catch (error) {
      const message = error?.response?.data?.errors?.base?.[0];
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const TaxAddNewLabel = createAsyncThunk(
  "TaxAddNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/tds/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("TaxAvailableLabels") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("TaxAvailableLabels", payload);

      return response?.data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else if (error?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors) {
        CommonToast({
          text: error?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const TaxRemoveNewLabel = createAsyncThunk(
  "TaxRemoveNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/tds/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else if (error?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors) {
        CommonToast({
          text: error?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

const taxCompliantViewAllSlice = createSlice({
  name: "taxCompliantViewAll",
  initialState: {
    storedPage: 1,
    toggle: false,
    isblur: false,
    TaxAccountAvailableLabels: [],

    taxCompliantViewAllData: null,
    taxCompliantViewAllLoading: null,
    taxCompliantViewAllError: null,

    addLabelsLoading: true,
    addLabelsData: [],
    addLabelsError: false,

    removeLabelsLoading: true,
    removeLabelsData: [],
    removeLabelsError: false,
  },
  reducers: {
    resetTaxToggle: (state) => {
      state.toggle = false;
    },
    resetTaxCompliantViewAll(state) {
      state.taxCompliantViewAllData = null;
      state.taxCompliantViewAllLoading = null;
      state.taxCompliantViewAllError = null;
    },
    resetLabelLoading: (state) => {
      state.addLabelsLoading = false;
      state.removeLabelsLoading = false;
    },
    setAvailabelLabels: (state, action) => {
      state.TaxAccountAvailableLabels = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(taxCompliantViewAll.pending, (state, action) => {
        state.taxCompliantViewAllLoading = true;
        if (action?.payload?.summary?.available_labels) {
          state.TaxAccountAvailableLabels = [];
        }
        state.taxCompliantViewAllError = null;
        state.taxCompliantViewAllData = null;
      })
      .addCase(taxCompliantViewAll.fulfilled, (state, action) => {
        state.taxCompliantViewAllLoading = false;

        state.TaxAccountAvailableLabels =
          action?.payload?.summary?.available_labels;
        if (action?.payload?.summary?.available_labels) {
          sessionStorage.setItem(
            "TaxAvailableLabels",
            JSON.stringify(action?.payload?.summary?.available_labels || []),
          );
        }
        state.taxCompliantViewAllError = null;
        state.taxCompliantViewAllData = action.payload;
      })
      .addCase(taxCompliantViewAll.rejected, (state, action) => {
        state.taxCompliantViewAllLoading = false;
        if (action?.payload?.summary?.available_labels) {
          state.TaxAccountAvailableLabels = [];
        }
        state.taxCompliantViewAllError = action.payload;
        state.taxCompliantViewAllData = null;
      });
    builder.addCase(TaxAddNewLabel.pending, (state, action) => {
      state.addLabelsLoading = true;
    });
    builder.addCase(TaxAddNewLabel.fulfilled, (state, action) => {
      state.addLabelsLoading = false;
      state.addLabelsData = action.payload;
    });
    builder.addCase(TaxAddNewLabel.rejected, (state, action) => {
      state.addLabelsLoading = false;
      state.addLabelsError = action.payload;
      state.addLabelsData = null;
    });
    builder.addCase(TaxRemoveNewLabel.pending, (state, action) => {
      state.removeLabelsLoading = true;
    });
    builder.addCase(TaxRemoveNewLabel.fulfilled, (state, action) => {
      state.removeLabelsLoading = false;
      state.removeLabelsData = action.payload;
    });
    builder.addCase(TaxRemoveNewLabel.rejected, (state, action) => {
      state.removeLabelsLoading = false;
      state.removeLabelsError = action.payload;
      state.removeLabelsData = null;
    });
  },
});

export const {
  resetTaxCompliantViewAll,
  resetTaxToggle,
  resetLabelLoading,
  setAvailabelLabels,
} = taxCompliantViewAllSlice.actions;

export default taxCompliantViewAllSlice.reducer;
